module.exports = __webpack_public_path__ + "img/bg_function03_2_m.d55e5b66.png";